// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recaptcha-notice[data-v-2f0da21a]{color:rgba(0,0,0,.6);font-size:12px;margin:12px 0 16px;word-break:break-word}.recaptcha-notice.white[data-v-2f0da21a]{color:hsla(0,0%,100%,.6)}.recaptcha-notice.white .linked[data-v-2f0da21a]{color:#fbe9f2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
